import React from "react";
import { Modal } from "antd";
import { Icon } from "Components";

interface CampaignLimitWarningModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CampaignLimitWarningModal: React.FC<CampaignLimitWarningModalProps> = ({
  visible,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={495}
      bodyStyle={{ padding: 0 }}
    >
      <div className="pmw-modal-container">
        <div className="pm-modal-header">
          <div className="pm-modal-header-left">
            <span className="pm-modal-title"></span>
          </div>
          <button
            className="pm-modal-close-icon"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon type="campaignModalClose" />
          </button>
        </div>

        <div className="pm-modal-body">
          <div className="pm-icon-box">
            <div className="pm-icon-wrapper">
              <div className="pm-icon-warning-modal">
                <Icon type="phishingManagerWarningModal" />
              </div>
            </div>
          </div>

          <p className="pm-modal-title-text">
            You’re approaching your campaign limit
          </p>

          <p>
            You are about to create your last available campaign under your current plan.
          </p>
          <br />
          <p>
            Once this campaign is created, you won’t be able to create additional campaigns.
          </p>
          <br />
          <p>
            To create more campaigns, please contact Customer Success to see available options.
          </p>
        </div>

        <div className="pm-modal-footer">
          <div className="pm-modal-footer-actions">
            <button className="pm-btn-plain" onClick={onClose}>
              Cancel
            </button>
            <button className="pm-btn-primary" onClick={onConfirm}>
              Create campaign
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CampaignLimitWarningModal;